import { Box, Container, Typography, Grid, Avatar, Card, CardContent } from "@mui/material";
import {  Favorite, Star, Verified } from "@mui/icons-material";

const reviews = [
    {
        name: "Faizan Ali",
        text: "Aise groups bohat kam milte hain jo sach mein knowledge badhate hain. Hats off to the admins aur members jo isay itna valuable bana rahe hain!"
      },
    {
      name: "Ali Khan",
      text: "Boht ala group hai bhai ka "
    },
    {
      name: "Fatima Ahmed",
      text: "I joined the premium group and it's been a game-changer for my career. The resources are amazing! Thank you! "
    },
    {
      name: "Usman Malik",
      text: "The premium packages are a steal! I got access to so many valuable courses and tools. Highly recommended! "
    },
    {
      name: "Ayesha Raza",
      text: "I was hesitant at first, but the premium content exceeded my expectations. It's worth every rupee! "
    },
    {
      name: "Bilal Hussain",
      text: "The premium group has been a lifesaver for me. The courses and support are incredible. Thank you! "
    },
    {
      name: "Sana Iqbal",
      text: "I joined the premium group and it's been the best decision ever. The content is so helpful and well-organized. "
    },

  ];

const UserReviews = () => {
  return (
    <Box sx={{
      background: 'linear-gradient(135deg, #ffffff, #f8f9fa)',
      py: 8,
      fontFamily: '"Noto Sans", sans-serif'
    }}>
      <Container maxWidth="lg">
        <Typography variant="h3" sx={{
          fontWeight: 700,
          mb: 6,
          color: '#2c3e50',
          textAlign: 'center',
          fontSize: { xs: '2rem', md: '2.5rem' },
          textTransform: 'uppercase',
          letterSpacing: '2px',
          position: 'relative',
          '&:after': {
            content: '""',
            position: 'absolute',
            bottom: -10,
            left: '50%',
            transform: 'translateX(-50%)',
            width: '60px',
            height: '4px',
            backgroundColor: '#3498db'
          }
        }}>
          User Reviews
        </Typography>

        <Grid container spacing={4}>
          {reviews.map((review, index) => (
            <Grid item xs={12} md={6} lg={4} key={index}>
              <Card sx={{
                height: '100%',
                borderRadius: 3,
                boxShadow: '0 8px 16px rgba(0, 0, 0, 0.1)',
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-5px)',
                  boxShadow: '0 12px 24px rgba(0, 0, 0, 0.2)'
                }
              }}>
                <CardContent sx={{
                  position: 'relative',
                  padding: 3,
                  '&:before': {
                    content: '"“"',
                    position: 'absolute',
                    top: 10,
                    left: 10,
                    fontSize: '4rem',
                    color: '#3498db',
                    opacity: 0.2
                  }
                }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <Avatar sx={{ 
                      bgcolor: '#3498db', 
                      mr: 2,
                      width: 40,
                      height: 40
                    }}>
                      {review.name[0]}
                    </Avatar>
                    <Typography variant="h6" sx={{ 
                      fontWeight: 600,
                      color: '#2c3e50'
                    }}>
                      {review.name}
                      <Verified sx={{ 
                        fontSize: 16, 
                        color: '#3498db', 
                        ml: 1,
                        verticalAlign: 'middle'
                      }} />
                    </Typography>
                  </Box>

                  <Typography variant="body1" sx={{
                    color: '#7f8c8d',
                    lineHeight: 1.6,
                    fontSize: '1rem',
                    position: 'relative',
                    pl: 2
                  }}>
                    {review.text}
                  </Typography>

                  <Box sx={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    mt: 2,
                    color: '#f1c40f'
                  }}>
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} sx={{ fontSize: 20 }} />
                    ))}
                  </Box>

                  <Favorite sx={{
                    position: 'absolute',
                    bottom: 10,
                    right: 10,
                    color: '#e74c3c',
                    opacity: 0.1,
                    fontSize: 40
                  }} />
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default UserReviews;